import { makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import { useAddToCart } from '../../../api/shoppingCart';
import AddToCartButtonToQty from '../../../components/AddToCartButtonToQty';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export interface ProductDetailAddToCartProps extends StandardDivProps<ProductDetailAddToCartClassKey> {
  product: ProductDetailProduct;
}

export type ProductDetailAddToCartClassKey = 'root' | 'topRow' | 'bottomRow' | 'qfWrapper' | 'cartInfo';

const themeSettings = { name: 'ProductDetailAddToCart' };

const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },

    topRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },

    bottomRow: {
      display: 'flex',
      justifyContent: 'flex-start',
      marginTop: theme.spacing(2),
      width: '100%',
      maxWidth: 260,
    },

    qfWrapper: {
      display: 'flex',
      alignItems: 'center',
    },

    cartInfo: {
      backgroundColor: '#002969',
      color: 'white',
      padding: '4px 8px',
      borderRadius: 4,
      fontSize: 12,
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
  }),
  themeSettings,
);

const ProductDetailAddToCart = React.forwardRef<HTMLDivElement, ProductDetailAddToCartProps>(
  ({ className, classes: pClasses, product }, ref) => {
    const classes = useStyles({ classes: pClasses });
    const t = useTranslateWithFallback();

    const {
      addToCart,
      quantity = 0,
      ...addToCartProps
    } = useAddToCart({
      forcePreventDecrement: true,
      product,
    });

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        {/* TOP ROW: Quantity + Button / Cart Info */}
        <div className={classes.topRow}>
          <div className={classes.qfWrapper}>
            <AddToCartButtonToQty {...addToCartProps} product={product} quantity={quantity} onAddToCart={addToCart} />
          </div>

          {quantity > 0 && (
            <div className={classes.cartInfo}>
              <strong>
                {quantity} {t(quantity === 1 ? 'app/pcsInCartUnitSingular' : 'app/pcsInCartUnitPlural')}
              </strong>{' '}
              {t('app/pcsInCart')}
            </div>
          )}
        </div>

        {/* BOTTOM ROW: Package buttons
        <div className={classes.bottomRow}>
          <CataloguePageListContentItemPackageButtons product={product as any} />
        </div> */}
      </div>
    );
  },
);

ProductDetailAddToCart.displayName = 'ProductDetailAddToCart';

export default withThemeProps(themeSettings)(ProductDetailAddToCart);
